import { useEffect, useState } from "react";

export const useFixHydration = () => {
  // Fix hydrated ssr
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted;
};
